import React from 'react';
import DownArrow from '../components/downArrow';
import SignupModal from '../components/SignupModal';
import {Link} from 'react-router';

export default class HomeSecond extends React.Component {

	constructor(props) {
		super(props);
		this.state= {
		 	showSignup: false,
		};
	}
h
	handleOpenSignup(){
		  this.setState({showSignup: true});
	};

	handleCloseSignup(){
	  this.setState({showSignup: false});
	};

	render(){
		return (

			<div>
				<div id="home_third" className="home_third hide_overflow">
					<div className="container h-100per">
						<div className="row h-100per">
							<div className="col-sm-6 full-height-col-sm h-50per-xs">

								<div className="outer-center">
									<div className="middle-center">
										<div className="inner-center home_third_content">
											<h1>Leverage your performance - Not your risk</h1>
											<div className="green_line"></div>
											<p>
											{"Tipigo is on the forefront of a new investing dynamic which allows you to outperform the markets without the need of using leverage or other risky strategies. It's fundamental, yet fundamentally different."}

											{/*
											Our unique investment practice synthesizes investment opportunities, data science, proven ratings from specialized analysts and intelligent machine learning.
											<br/>
											Welcome to a new world of investment that is consistently ahead of the pack - without the risk of leverage.
											*/}

											</p>
											<br/>
											<Link to="contact_us" className="btn tipigo-vp-btn btn-raised btn-success">Ask us how</Link>
											{/* onTouchTap={this.handleOpenSignup.bind(this)} */}
											{/*<SignupModal handleClose={this.handleCloseSignup.bind(this)} open={this.state.showSignup}></SignupModal>*/}
										</div>
									</div>
								</div>
							</div>
							<div className="col-sm-6 full-height-col-sm h-50per-xs">

								<div className="outer-center">
									<div className="middle-center">
										<div className="inner-center">
											<img className="rw_img" alt="risk reward" src={require("../../img/risk-reward-img.png")}/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* <DownArrow elementId="home_third_footer"></DownArrow> */}

			    </div>
			    <div id="home_third_footer" className="home_third_footer">
			    	<div className="container">
			    		<div className="row">
			    			<div className="col-sm-4 home_six_contant_height">

			    				<div className="outer-center">
			    					<div className="middle-center">
			    						<div className="inner-center">
			    							<div className="home_third_footer_content">

			    								<img src={require("../../img/homethird_icon1.png")}/>
			    								<h3>Custom Automation</h3>

			    								<p>
			    									Semi to fully automated platform that is extremely simple to use.

			    									Our intelligent advisor will find and manage a customized porfolio suitable to your preferences - just sit back and enjoy the ride.
			    								</p>
			    							</div>
			    						</div>
			    					</div>
			    				</div>

			    			</div>

			    			<div className="col-sm-4 home_six_contant_height">

			    				<div className="outer-center">
			    					<div className="middle-center">
			    						<div className="inner-center">
			    							<div className="home_third_footer_content">

			    								<img src={require("../../img/homethird_icon2.png")}/>

			    								<h3>Consistent Long Term Results</h3>
			    								<p>After years of puting theory into practice, our system has been thoroughly tested to deliver exceptional overperformance - without leverage and with minimal effort on your part.</p>
			    							</div>
			    						</div>
			    					</div>
			    				</div>
			    			</div>

			    			<div className="col-sm-4 home_six_contant_height">

			    				<div className="outer-center">
			    					<div className="middle-center">
			    						<div className="inner-center">
			    							<div className="home_third_footer_content">

			    								<img src={require("../../img/homethird_icon3.png")}/>
			    								<h3>Flexible Versatility</h3>

			    								<p>
			    									For individual investors, or institutionals, Tipigo reveals timely insight on investment opportunities.
			    									<br/>Use Tipigo's platform as a standalone or as a valuable decision support engine.
			    								</p>
			    							</div>
			    						</div>
			    					</div>
			    				</div>

			    			</div>
			    		</div>

			    	</div>
			    </div>

			</div>

		);
	}

}



// WEBPACK FOOTER //
// ./src/js/components/HomeThird.js